import Navbar from '@/components/custom/ui/landing/navbar'
import navConfig from '@/constant/config/landing/navconfig'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_landing')({
  component: RouteComponent,
})


function RouteComponent() {
  return (
    <div >
      <div className="fixed top-0 left-0 w-full z-50">
        <Navbar {...navConfig} />
      </div>      <Outlet />
    </div>
  )
};
